<template>
  <el-dialog
    class="audio-player"
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    @close="closeHandle"
    style="z-index: 10000"
    v-if="dialogVisible"
  >
    <audio :src="audio_src" controls></audio>
  </el-dialog>
</template>

<script>
/*
音频播放器
*/
export default {
  name: "audioPlayer",
  props: {
    dialogTitle: {
      type: String,
      default: "播放音频"
    },
    visible: {
      type: Boolean,
      default: false
    },
    audio_src: {
      type: String,
      default: ""
    },
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    closeHandle() {
      this.$emit('dialogClose')
    },
  }
}
</script>

<style lang="scss" scoped>
.audio-player{
  text-indent: 0;
}
</style>